<template>
  <div class="page">
    <div class="app-container">
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch>
	  <el-button type="primary" @click="handleExport"
	    ><i class="el-icon-download"></i> 导出</el-button
	  >
      <BaseTable
        ref="baseTable"
        url="/admin/Census/xttjList"
        :tableData.sync="tableData"
        :searchParams="searchData"
        :columns="columns"
      >
	  <template #handle="{ row }">
	    <el-button type="text" @click="hanldeRow(row, 'whetherxt')">续统</el-button>
	  </template>
      </BaseTable>
    </div>
  </div>
</template>

<script>
import { searchFormOption } from "./formOptions";
import { columns } from "./columns";

export default {
  name: "usage",
  comments: {},
  data() {
    return {
      tableData: [],
      orgOption: [],
      searchData: {date: [this.$moment().format("YYYY-MM-DD"),this.$moment().add(1,'years').format("YYYY-MM-DD")]},
    };
  },
  computed: {
    columns,
    searchFormOption,
  },
  created() {
    this.getOrg();
	this.$store.dispatch('app/getCarType')
  },
  methods: {
    getOrg() {
      this.$api.post("/admin/org/index", {}).then((res) => {
        this.orgOption = res?.data?.data;
      });
    },
	async handleExport() {
	  const res = await this.$api.post(
	    "/admin/Census/xttjList",
	    { is_export: 1, ...this.searchData },
	    "导出"
	  );
	  window.open("https://" + res.data);
	},
	hanldeRow(row, k) {
	  switch (k) {
	    case "whetherxt":
	      this.$router.push({
	        path: "/issue/recording",
	        query: {
	          insBillId: row.insBillId,
			  whetherxt: 1
	        },
	      });
	      break;
	    default:
	      break;
	  }
	},
    // 点击搜索
    handleSearch() {
      this.$refs.baseTable.searchData();
    },
    // 搜索参数拦截
    paramsCepCallback(params) {
      console.log(params);
      return {
        ...params,
        ...this.searchData,
      };
    },
  },
};
</script>
